import { useAllThemes } from './all-themes-context';
export default useAllThemes;